angular.module('app.controllers').controller 'FavoritesListCtrl', [
  '$scope', '$rootScope', 'APIFavorites'
].append (self, root, APIFavorites) ->
  
  shortcode = root.user?.shortcode || root.tuser || 'test'

  self.day = 1
  self.setDay =  (day) ->
    self.day = day   

  self.days = [
    {
      title: '20.05'
      title_sm: '.25'
      day: 1
    }
  ]

  self.loadData = (entrycode, slug) ->
    APIFavorites.query {entrycode: entrycode, fullentry: true, shortcode: shortcode, tuser: root.tuser || null, lang: root.lang || 'es'}, (data) ->
      self[slug] = data  
      if entrycode is 'sl' && self.slots.length
        return if self.slots.filter((slot) -> slot.day_int == 1).length
        return self.day = 2 unless self.slots.filter((slot) -> slot.day_int == 1).length
        return self.day = 3 unless self.slots.filter((slot) -> slot.day_int == 2).length

    , (response) ->
      UI.notify false, response.error.data

  self.loadData('ex', 'exhibitors')
  self.loadData('vi', 'videos')
  self.loadData('sl', 'slots')
  self.loadData('us', 'users')
  self.loadData('do', 'downloads')
  self.loadData('li', 'links')

  slugs = 
    'ex': 'exhibitors'
    'vi': 'videos'
    'sl': 'slots'
    'us': 'users'
    'do': 'downloads'
    'li': 'links'

  root.$on 'forceFavs', (event, entrycode, slug = null, fav_code) ->
    return unless self.at('favs')
    slug = slugs[entrycode] unless slug?
    fav_index = self[slug].findIndex((item) -> item.fav_code == fav_code)
    self[slug].splice(fav_index, 1)

    if entrycode is 'sl' && self.slots.length
      self.day = self.slots[0].day_int unless self.slots.filter((slot) -> slot.day_int == self.day).length
    
  self.openProgramModal = (data = null, id = null) ->
    root.$broadcast 'onProgramModalOpen', data, id